import { isEqual } from "es-toolkit";
import { DependencyList, EffectCallback, useEffect, useRef } from "react";

/**
 * 依存配列をディープコンペア（深い比較）するカスタムuseEffectフック。
 * オブジェクトや配列を依存関係に持つ場合に、値が実質的に変更されたときだけeffectを再実行したい場合に使用します。
 *
 * @param callback - `useEffect` と同じeffectコールバック関数。
 * @param dependencies - `useEffect` と同じ依存配列。`isEqual` で深く比較されます。
 */
export function useDeepCompareEffect(
  callback: EffectCallback,
  dependencies: DependencyList,
) {
  // useEffect の依存関係は deep equal で判定するため、
  // useDeepCompareMemoize によるラップを使用している。
  // 通常の依存配列を直接指定すると shallow equal での比較となり、
  // 本来の意図と異なるため、このルールを無視する。
  // biome-ignore lint/correctness/useExhaustiveDependencies: 上記参照
  useEffect(callback, useDeepCompareMemoize(dependencies));
}

function useDeepCompareMemoize(value: DependencyList): DependencyList {
  const ref = useRef<DependencyList>([]);

  if (!isEqual(ref.current, value)) {
    ref.current = value;
  }

  return ref.current;
}
